export default __webpack_public_path__ + "static/media/dtb-logo.1f6e0bd2.webp";